module.exports = __webpack_public_path__ + "img/146.ba6a080d.jpg";